import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchCreateGroupFailure,
  fetchCreateGroupSuccess,
} from "../slices/features/createGroup";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* createGroupSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.createGroup,
      baseUrl,
      id,
      data
    );

    yield put(fetchCreateGroupSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchCreateGroupFailure({ statusCode, statusText }));
  }
}

export function* watchCreateGroup() {
  yield takeLatest(RequestTypes.CREATE_GROUP_REQUEST, createGroupSaga);
}
